"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCEL_CLOSE_USER = exports.CLOSE_USER = exports.INVITE_CODE_REWARD = exports.USER_UNBIND_EMAIL = exports.USER_UNBIND_MOBILE = exports.USER_INTEGRAL_RECORDS = exports.USER_CREDIT = exports.UN_BIND = exports.BIND_MOBILE = exports.BIND_EMAIL = exports.REFRESH_API_KEY = exports.CREATE_API_KEY = exports.RETRIEVE_PWD = exports.UPDATE_PWD = exports.UPDATE_USER = exports.EMAIL_BIND = exports.LINK_INVITE_EMAIL = exports.EMAIL_VALIDATE = exports.USER_VALIDATE = exports.USER_CAN_LOGOUT = exports.USER_ME = void 0;
// ================ Account ======================
/**
 * Get My Info (me)
 */
exports.USER_ME = '/user/me';
/**
  * Check if the user can close or delete
  */
exports.USER_CAN_LOGOUT = '/user/checkForClosing';
/**
  * Validate phone number and check if it has been registered
  */
exports.USER_VALIDATE = '/user/validate';
/**
  * Space - check if the user's email is the same as the specified email
  */
exports.EMAIL_VALIDATE = '/user/validate/email';
/**
  * Space - binding the invited email
  */
exports.LINK_INVITE_EMAIL = '/user/link/inviteEmail';
/**
  * Space - check if the user has bound the email
  */
exports.EMAIL_BIND = '/user/email/bind';
/**
  * Update (Edit) the user info
  */
exports.UPDATE_USER = '/user/update';
/**
  * Change password
  */
exports.UPDATE_PWD = '/user/updatePwd';
/**
  * Getting back the password
  */
exports.RETRIEVE_PWD = '/user/retrievePwd';
/**
  * Create developer access token
  */
exports.CREATE_API_KEY = '/user/createApiKey';
/**
  * Refresh developer access token
  */
exports.REFRESH_API_KEY = '/user/refreshApiKey';
/**
  * Bind Email
  */
exports.BIND_EMAIL = '/user/bindEmail';
/**
  * Bind phone number
  */
exports.BIND_MOBILE = '/user/bindPhone';
/**
  * UnBind 3rd social account
  */
exports.UN_BIND = '/user/unbind';
/**
  * Get user's points/credit
  */
exports.USER_CREDIT = '/user/integral';
/**
  * query user's points/credit with with pagination
  */
exports.USER_INTEGRAL_RECORDS = '/user/integral/records';
/**
  * Unbind phone number
  */
exports.USER_UNBIND_MOBILE = '/user/unbindPhone';
/**
  * Unbind email
  */
exports.USER_UNBIND_EMAIL = '/user/unbindEmail';
/**
  * invite code reward
  */
exports.INVITE_CODE_REWARD = '/user/invite/reward';
// ================ User Authentication ====================
// Close user, delete user
exports.CLOSE_USER = '/user/applyForClosing';
// cancel delete user
exports.CANCEL_CLOSE_USER = '/user/cancelClosing';
//# sourceMappingURL=url.user.js.map